import React from 'react';
import { Route, Switch } from 'react-router-dom';
import P, { InferProps } from 'prop-types';
import SocialInteractionScene from './social-interaction';

function SocialInteraction({ match }: InferProps<typeof SocialInteraction.propTypes>) {
  return (
    <Switch>
      <Route exact path={`${match.url}/:abbrv`} component={SocialInteractionScene} />
    </Switch>
  );
}

SocialInteraction.propTypes = {
  match: P.shape({
    url: P.string.isRequired,
  }).isRequired,
};

export default SocialInteraction;
